import type { ReactNode } from 'react';
import TextContentSep from '../common/TextContentSep';

export type SampleAccentHeadingProps = {
  icon?: string;
  children: ReactNode;
  trailing?: ReactNode;
  className?: string;
  /** タイトル要素（フォームは h5、パネル内は span） */
  titleAs?: 'h5' | 'span';
  /** 直後のフォームフィールドとの textContent 食い込み防止（Card ヘッダ＋Body では不要） */
  contentSepAfter?: boolean;
};

/** パネル／フォーム共用の左アクセント見出し本体 */
export function SampleAccentHeading({
  icon,
  children,
  trailing,
  className,
  titleAs = 'span',
  contentSepAfter = false,
}: SampleAccentHeadingProps) {
  const TitleTag = titleAs;
  return (
    <div
      className={`sample-accent-strip d-flex align-items-center justify-content-between gap-2${className ? ` ${className}` : ''}`.trim()}
    >
      <TitleTag className="sample-accent-strip-title mb-0">
        {icon ? (
          <i className={`fas ${icon} sample-accent-strip-icon`} aria-hidden="true" />
        ) : null}
        {children}
      </TitleTag>
      {trailing ? (
        <>
          <TextContentSep />
          {trailing}
        </>
      ) : null}
      {contentSepAfter ? <TextContentSep /> : null}
    </div>
  );
}
